import { Button, KIND, SIZE, SHAPE } from 'baseui/button';
import { Cell } from 'baseui/layout-grid';
import { Check, Plus } from 'react-feather';
import { LabelMedium } from 'baseui/typography';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { styled } from 'baseui';
import * as React from 'react';
import { BaseLi } from '../common/list';
import type { FollowUpType, QnAStateType } from '../../reducers';
import { VSpacer } from '../common/layout';
import { updateFollowUp } from '../../utils/compat';
import Conditions from './Conditions';
import Question from './Question';
import QuestionList from '../common/QuestionList';
const FollowUpList = styled('ol', {
  padding: 0,
  margin: 0
});
type Props = {
  state: QnAStateType;
  followUps: Array<FollowUpType>;
  parentId: string;
  updateQuestion: Function;
  addQuestion: Function;
  addConditionalQuestion: Function;
  setModal: Function;
  removeQuestion: Function;
};
const FollowUps = ({
  state,
  followUps,
  parentId,
  updateQuestion,
  addQuestion,
  addConditionalQuestion,
  setModal,
  removeQuestion
}: Props) => {
  const [editMode, setEditMode] = React.useState(false);
  if (isEmpty(followUps)) return null;
  return <FollowUpList onClick={e => {
    e.stopPropagation();
    setEditMode(true);
  }}>
      <LabelMedium>Follow Up Questions</LabelMedium>
      <VSpacer />
      {followUps.map((followUp, followUpIdx) => {
      const followUpQuestionIds = get(updateFollowUp(followUp), 'questionIds') || [];
      return <BaseLi key={`condition-${followUpIdx}`}>
            <QuestionList>
              {typeof followUpIdx === 'number' && parentId && <Cell span={[4, 8, 12]}>
                  <React.Fragment>
                    <LabelMedium>Conditions</LabelMedium>
                    <VSpacer />
                    <Conditions state={state} updateQuestion={updateQuestion} followUp={followUp} followUpIdx={followUpIdx} followUpOwnderId={parentId} editMode={editMode} setEditMode={setEditMode} />
                  </React.Fragment>
                  {editMode && <div>
                      <Button onClick={e => {
                e.stopPropagation();
                setEditMode(false);
              }} size={SIZE.compact} shape={SHAPE.pill}>
                        <Check /> Done
                      </Button>{' '}
                      <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
                addConditionalQuestion(parentId, followUpIdx);
              }}>
                        <Plus /> Add question
                      </Button>
                    </div>}
                </Cell>}
              {followUpQuestionIds.map(followUpQuestionId => {
            return <React.Fragment key={`followup-question-${followUpQuestionId}-${followUpIdx}`}>
                    <Question parentId={parentId} followUp={followUp} followUpIdx={followUpIdx} followUpOwnderId={parentId} questionId={followUpQuestionId} state={state} updateQuestion={updateQuestion} addQuestion={addQuestion} addConditionalQuestion={addConditionalQuestion} setModal={setModal} removeQuestion={removeQuestion} />
                  </React.Fragment>;
          })}
            </QuestionList>
          </BaseLi>;
    })}
    </FollowUpList>;
};
export default React.memo<Props>(FollowUps);